import React, { useContext, useMemo } from 'react'
import { ScenarioStatesProviderContext } from '../providers/StatesProvider'

const useStaticData = () => {
    const context = useContext(ScenarioStatesProviderContext)
    if (context === undefined) {
        throw new Error('useStaticData must be used within a Scenario States Provider')
    }

    const { scenarioBaseData, setScenarioBaseData, loading, satelliteBaseDataLoaded } = context
    const { allGroups, allStations, allFaults, allTaskPlans, allGeoFeatures, allPayloads, allHwilComponents, allSubsystems } = useMemo(() => scenarioBaseData, [scenarioBaseData])
    return { allGroups, allStations, allFaults, allTaskPlans, allGeoFeatures, allPayloads, allHwilComponents, allSubsystems, setScenarioBaseData, loading, satelliteBaseDataLoaded }
}

export default useStaticData